import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from '../../../config/axios';
import { Button, Meta } from '../../components/Atoms';
import AuthShell, { AuthError, AuthSuccess } from './AuthShell';

/**
 * RestoreAccount - cofnięcie usunięcia konta.
 *
 * User dostaje email z linkiem (30 dni od kasacji) - klik → ten ekran →
 * przycisk "Przywróć" → POST /api/auth/account/restore z tokenem.
 *
 * Po success - backend ustawia httpOnly cookie (auto-login), więc hard
 * redirect do /dashboard żeby AuthProvider zrobił świeży mount.
 */

export default function RestoreAccount() {
  const { token } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleRestore = async () => {
    setLoading(true);
    setError('');
    try {
      await axios.post('/api/auth/account/restore', { token });
      setSuccess(true);
      setTimeout(() => { window.location.href = '/dashboard'; }, 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Nie udało się przywrócić konta.');
      setLoading(false);
    }
  };

  if (success) {
    return (
      <AuthShell
        eyebrow="Witamy z powrotem"
        title={<>Konto <span style={{ fontStyle: 'italic', color: 'var(--t-sage)' }}>przywrócone</span>.</>}
        subtitle="Wszystkie dane są bezpieczne. Za chwilę zalogujemy Cię do aplikacji."
      >
        <AuthSuccess>Twoje działki, grządki i zdjęcia czekają tam, gdzie je zostawiłeś.</AuthSuccess>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      eyebrow="Przywróć konto"
      title={<>Tęsknimy. <span style={{ fontStyle: 'italic', color: 'var(--t-sage)' }}>Wracaj</span>.</>}
      subtitle="Twoje konto zostało oznaczone do usunięcia, ale jeszcze nic nie przepadło. Kliknij poniżej, żeby je odzyskać razem z wszystkimi działkami i zdjęciami."
      footer={
        <Meta style={{ opacity: 0.7 }}>
          Link aktywny 30 dni od momentu usunięcia konta
        </Meta>
      }
    >
      <AuthError>{error}</AuthError>

      <Button
        full
        onClick={handleRestore}
        variant={loading ? 'ghost' : 'primary'}
      >{loading ? 'Przywracam…' : 'Przywróć moje konto'}</Button>

      <div style={{
        marginTop: 18, padding: '14px 16px',
        borderRadius: 10,
        background: 'rgba(168, 196, 158, 0.06)',
        borderLeft: '3px solid var(--t-sage)',
        fontSize: 12, color: 'var(--t-text-dim)', lineHeight: 1.5,
      }}>
        <strong style={{ color: 'var(--t-sage)' }}>Co odzyskasz:</strong> wszystkie działki,
        grządki, zdjęcia, notatki dziennika i zaplanowane sukcesje. Całość Twojego sezonu.
      </div>
    </AuthShell>
  );
}
